import { connect } from 'react-redux';

import QuantityLimit from '../components/QuantityLimit';

const mapStateToProps = state => {
  return {
    isMembershipOrder: state.currentOrder.membership_order,
  };
};

export default connect(mapStateToProps)(QuantityLimit);
